import { Grid } from '@mui/material';

import { MarketCardSkeleton } from '../../common';

export const SportsPropsSkeleton = () => {
  return (
    <Grid container spacing={2}>
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <Grid item xs={12} sm={6} md={4} key={i}>
          <MarketCardSkeleton />
        </Grid>
      ))}
    </Grid>
  );
};

export default SportsPropsSkeleton;
